<div class="slide-notify ag-pa-md">
  <div *ngIf="notifications && notifications?.alllMessageCount > 0">
    <h5 class="text=center">Your notifications</h5>
    <mat-card
      *ngFor="let item of notifications?.allMessages; let i = index"
      class="example-card alert-info"
      [ngClass]="{ 'alert-info': !item?.unRead, 'alert-warning': item?.unRead }"
      (click)="openNotification(item, i)"
    >
      <mat-card-header>
        <mat-card-title>{{ item?.msgTitle }}</mat-card-title>
      </mat-card-header>
      <mat-card-content class="slide-notify__mat-card-content">
        <div class="ellipsis" [innerHTML]="item?.msgText"></div>
        <div *ngIf="item?.msgBegin">
          {{ isoFormatDMY(parseISOString(item?.msgBegin), item?.msgBegin) }}
        </div>
        <hr />
        <div *ngIf="item?.msgSignature">{{ item?.msgSignature }}</div>
      </mat-card-content>
    </mat-card>
  </div>

  <div *ngIf="notifications && notifications?.alllMessageCount === 0">
    <h6 class="red">There are no notifications at this time</h6>
  </div>

  <div *ngIf="!notifications">
    <h6 class="red">There are no notifications at this time</h6>
  </div>
</div>
